import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-dialog-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  /**
   * 알림창 제목
   */
  title: string = '';

  /**
   * 메시지 내용
   */
  message: string = '';

  /**
   * 컨펌 다이얼로그 여부 (true : 컨펌용, false : 알림용)
   */
  confirm: boolean = false;

  /**
   * 자세히 버튼 표시 여부 (true : 표시, false : 미표시)
   */
  detail: boolean = false;

  constructor(public dialogRef: NbDialogRef<AlertComponent>) {}

  ngOnInit(): void {}
}
